<template>
        <div class="mainpage">
            <div class="whitebox t_center">
                <h1>Welcome to kinktest.org</h1>
                <p>Your archetype in BDSM may change over time, we suggest you sign up for a free account so that we can record your results for each time.</p>
                <router-link tag="button" to="/test">No, I want to do it anonymously now.</router-link>
                <router-link tag="button" to="/signup">Yes, I’d like to sign up now.</router-link>
                <p>By using this website you confirm that you are 18+.</p>
            </div><!--whitebox end--->
        </div><!--mainpage end--->
</template>
<script>
    export default {
        name:"starttest"
    }
</script>

<style scoped>

</style>
